import { useNetworkBoundariesLayer } from "../../features/geospatialProjects/hooks/useNetworkBoundariesLayer";
import { CoamAreaFeature } from "../../features/geospatial/api/coamArea";

interface NetworkBoundariesLayerMapboxProps {
  map: mapboxgl.Map | null;
  features: CoamAreaFeature[];
}

export const NetworkBoundariesLayerMapbox: React.FC<NetworkBoundariesLayerMapboxProps> = ({
  map,
  features,
}) => {
  useNetworkBoundariesLayer({ map, features });
  return null;
};

